import React from 'react';

const PURPLE = '#a24aa2';
const BORDER = '#ccc';

/**
 * Mesma estrutura e destaque de coluna que o PDF (extrato.blade.php).
 */
export default function ExtratoFaixaConsumoTable({ resume, tabela }) {
  if (!tabela || !tabela.nomes_perfis || !tabela.nomes_perfis.length) {
    return null;
  }

  const res = resume.resumo || {};
  const nomeRef = (res.referencia && (res.referencia.nome || res.referencia.nivel)) || '';
  const faturamento = !resume.a_vista;
  const nomesPerfis = tabela.nomes_perfis;
  const consumosMinimos = tabela.consumos_minimos || {};
  const produtos = tabela.produtos || {};

  const minimoVals = nomesPerfis.map((nomeCol) => consumosMinimos[nomeCol]);

  return (
    <div style={{ overflowX: 'auto' }}>
      <table
        style={{
          width: '100%',
          borderCollapse: 'collapse',
          tableLayout: 'fixed',
          fontSize: 12,
          marginTop: 4,
        }}
      >
        <thead>
          <tr>
            <th
              style={{
                border: `1px solid ${BORDER}`,
                padding: '6px 8px',
                textAlign: 'left',
                width: '20%',
              }}
            >
              Faixa de Consumo
            </th>
            {nomesPerfis.map((nomePerfil) => {
              const isRef = nomePerfil === nomeRef;
              return (
                <th
                  key={nomePerfil}
                  style={{
                    border: `1px solid ${BORDER}`,
                    padding: 0,
                    verticalAlign: 'top',
                    textAlign: 'center',
                    borderLeft: isRef ? `2px solid ${PURPLE}` : `1px solid ${BORDER}`,
                    borderRight: isRef ? `2px solid ${PURPLE}` : `1px solid ${BORDER}`,
                    borderTop: isRef ? `2px solid ${PURPLE}` : `1px solid ${BORDER}`,
                  }}
                >
                  {isRef ? (
                    <React.Fragment>
                      <div style={{ background: PURPLE, color: '#fff', fontWeight: 600, padding: '8px 6px' }}>Faixa de Referência</div>
                      <div style={{ padding: '6px 6px 8px', fontWeight: 600, color: '#000' }}>{nomePerfil}</div>
                    </React.Fragment>
                  ) : (
                    <div style={{ padding: '8px 6px' }}>{nomePerfil}</div>
                  )}
                </th>
              );
            })}
          </tr>
          <tr>
            <th
              style={{
                border: `1px solid ${BORDER}`,
                padding: '6px 8px',
                textAlign: 'left',
              }}
            >
              Mínimo
            </th>
            {nomesPerfis.map((nomePerfil, i) => {
              const isRef = nomePerfil === nomeRef;
              const val = minimoVals[i];
              return (
                <th
                  key={`min-${nomePerfil}`}
                  style={{
                    border: `1px solid ${BORDER}`,
                    padding: '6px 8px',
                    textAlign: 'center',
                    color: '#c62828',
                    borderLeft: isRef ? `2px solid ${PURPLE}` : `1px solid ${BORDER}`,
                    borderRight: isRef ? `2px solid ${PURPLE}` : `1px solid ${BORDER}`,
                  }}
                >
                  {faturamento ? val : 'Não aplicável'}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {Object.keys(produtos).map((titulo, rowIndex, rows) => {
            const row = produtos[titulo];
            const keys = Object.keys(row);
            const vals = Object.values(row);
            const isLastRow = rowIndex === rows.length - 1;
            return (
              <tr key={titulo}>
                <td style={{ border: `1px solid ${BORDER}`, padding: '6px 8px', textAlign: 'left' }}>{titulo}</td>
                {nomesPerfis.map((nomeCol, i) => {
                  const nivelKey = keys[i];
                  const preco = vals[i];
                  const isRef = nivelKey === nomeRef;
                  return (
                    <td
                      key={`${titulo}-${nomeCol}`}
                      style={{
                        border: `1px solid ${BORDER}`,
                        padding: '6px 8px',
                        textAlign: 'center',
                        color: '#c62828',
                        fontWeight: 600,
                        borderLeft: isRef ? `2px solid ${PURPLE}` : `1px solid ${BORDER}`,
                        borderRight: isRef ? `2px solid ${PURPLE}` : `1px solid ${BORDER}`,
                        borderBottom: isRef && isLastRow ? `2px solid ${PURPLE}` : `1px solid ${BORDER}`,
                      }}
                    >
                      {preco}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
